class GlobalStorageService {
  private static _nonce:string | null = null;
  private static _qwid:string | null = null;

  public static setNonce(nonce:string){
    this._nonce = nonce;
  }
  public static setQwid(qwid:string){
    this._qwid = qwid;
  }

  public static getNonce():string | null {
    return this._nonce;
  }
  public static getQwid():string | null {
    return this._qwid;
  }

  public static clearStorage(){
    this._nonce = null;
    this._qwid = null;
  }
}

export default GlobalStorageService;